import { common } from '../styles';

export default {
  label: {
    cursor: 'pointer',
  },
  icon: {
    width: '40px',
    height: '40px',
    ...common,
  },
  heading: {
    fontSize: 14,
    fontWeight: 600,
    color: '#242A42',
  },
  helper: {
    fontSize: 12,
    fontWeight: 400,
  },
};
